import RoundedButton from 'components/RoundedButton';
import { useCtaButtonTextAndHref } from 'hooks/cta/useCtaButtonTextAndHref';
import { observer } from 'mobx-react-lite';

import styles from './EntriesAndStats.module.css';

const ChoosePlanSection = observer(({ title }: { title: string }) => {
  const cta = useCtaButtonTextAndHref();

  return (
    <div className={`textAlignCenter ${styles.choosePlanSection}`}>
      <div>
        <h3 className="aboutUsTypographyHeaderMedium">{title}</h3>
        <p className="noMargin">Choose a plan to start playing</p>
      </div>
      <RoundedButton rebrandDm2025 href={cta.href} onClick={cta.onClick}>
        Choose your plan
      </RoundedButton>
    </div>
  );
});

export default ChoosePlanSection;
